import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Avatar,
  CircularProgress,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const ResponsiveAppBar = () => {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('authToken');
        const userId = localStorage.getItem('userId');
        
        if (!token || !userId) {
          setLoading(false);
          return;
        }

        const response = await fetch(`http://localhost:5001/api/homeowners/profile/${userId}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch user');
        }

        const data = await response.json();
        setUserEmail(data.email);
      } catch (err) {
        console.error('Error fetching user:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const handleProfileClick = () => {
    navigate('/profile');
  };

  return (
    <StyledAppBar position="fixed">
      <StyledToolbar>
        <MobileMenuButton edge="start" color="inherit" aria-label="menu">
          <MenuIcon />
        </MobileMenuButton>

        <WelcomeText variant="h6">
          {loading ? (
            <LoadingContainer>
              <StyledCircularProgress size={20} />
            </LoadingContainer>
          ) : error ? (
            'Welcome'
          ) : (
            `Welcome, ${userEmail ? userEmail.split('@')[0] : 'User'}`
          )}
        </WelcomeText>

        <ProfileSection>
          <ProfileButton onClick={handleProfileClick}>
            <StyledAvatar>
              <AccountCircleIcon />
            </StyledAvatar>
          </ProfileButton>
        </ProfileSection>
      </StyledToolbar>
    </StyledAppBar>
  );
};

const StyledAppBar = styled(AppBar)`
  && {
    background: #2c3e50;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-left: 250px;
    width: calc(100% - 250px);

    @media (max-width: 768px) {
      margin-left: 0;
      width: 100%;
    }
  }
`;

const StyledToolbar = styled(Toolbar)`
  && {
    justify-content: space-between;
    padding: 0.5rem 2rem;
    min-height: 64px;
  }
`;

const MobileMenuButton = styled(IconButton)`
  && {
    display: none;
    margin-right: 1rem;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;

const WelcomeText = styled(Typography)`
  && {
    color: white;
    font-weight: 500;
    flex-grow: 1;
  }
`;

const ProfileSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const ProfileButton = styled(IconButton)`
  && {
    color: white;
    padding: 0;
    
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
`;

const StyledAvatar = styled(Avatar)`
  && {
    background: #34495e;
    transition: all 0.3s ease;

    &:hover {
      background: #FF5722;
    }
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledCircularProgress = styled(CircularProgress)`
  && {
    color: white;
  }
`;

export default ResponsiveAppBar;
